/**
 * Returns a thunk that accepts the selector function to pick the state with
 * @param {string} stateKey
 */
function reexportSelector(stateKey) {
  /**
   * Thunk
   * @param {T} selectorFn
   * @returns {T} The selector function
   * @template T
   */
  function thunk(selectorFn) {
    return (state, ...args) => selectorFn(state[stateKey], ...args);
  }
  return thunk;
}

export default reexportSelector;
